module.exports = __webpack_public_path__ + "static/media/sliderItem9.c61601e9.JPG";